"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'voice-chat.error.noModelOrAvatar': 'Please select either a model or avatar to start voice conversation.',
};
